// Кнопки подложки листа входа (лендинг, приветствие) просят хост (auth/auth-host.tsx)
// открыть лист — событием окна, без общего контекста: лендинг и приветствие не тянут
// в свои бандлы сам хост со шторкой и формами (ТЗ WEB-LOOK Э1.4–Э1.5).

export type AuthEvent = 'login' | 'register' | 'tour';

/** Имя события окна. */
export const AUTH_EVENT = 'scr-auth';

/** Открыть лист входа/регистрации с любой кнопки страницы; 'tour' — начался мини-тур:
 *  лист (если открыт) уходит. */
export function openAuth(kind: AuthEvent): void {
  window.dispatchEvent(new CustomEvent(AUTH_EVENT, { detail: kind }));
}
